export const removeAdmin = async (userID, setRemoveAdminStatusMessage) => {
  try {
    const response = await fetch(
      "https://wad-backend.ws381566.remote.ac/removeAdmin.php?adminRequired=true&userID=" + userID,
      {
        method: "DELETE",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        mode: "cors",
      }
    );

    const result = await response.json();

    if (result.status === "authenticationError") {
      window.location.href = "/login";
      return;
    }

    if (result.status === "success") {
      setRemoveAdminStatusMessage(result.message);
    } else {
      setRemoveAdminStatusMessage(result.message || "Failed to execute query");
    }
  } catch (error) {
    setRemoveAdminStatusMessage(error.message);
  }
};